import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { StoreGroup } from '../../../../../models/store-common.model';
import { StoreCommonService } from '../../../../../services/store/store-common.service';

@Component({
  selector: 'app-store-group-list-form',
  templateUrl: './store-group-list-form.component.html',
  styles: ['label.required:after {top: 0}']
})
export class StoreGroupListFormComponent implements OnInit {

  @Input() editingElement: StoreGroup;
  @Output() onAddElement: EventEmitter<any> = new EventEmitter<any>();
  @Output() onUpdateElement: EventEmitter<any> = new EventEmitter<any>();

  addEditFormDetails: FormGroup;

  fields: any;
  public invalidSubmit: boolean;

  constructor(
    private fb: FormBuilder,
    public svc: StoreCommonService) {
  }

  ngOnInit() {

    this.svc.getStoreGroupFields().subscribe(res => {
      this.fields = res;
    });

    this.addEditFormDetails = this.fb.group({
      'code': new FormControl(this.editingElement.code),
      'name': new FormControl(this.editingElement.name)
    });
  }

  saveOrUpdate(): void {

    if (!this.addEditFormDetails.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let newData = Object.assign({}, this.editingElement, this.addEditFormDetails.value);
    if (newData.id == null) {
      this.onAddElement.emit(newData);
    } else {
      this.onUpdateElement.emit(newData);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-group/store-group-list/store-group-list-form.component.ts